import { connect } from "react-redux";
import { getAdUnitPath } from "./getAdUnitPath";

const mapStateToProps = (pageType, floorSelector) => state => ({
  adUnitPath: getAdUnitPath(state, pageType, floorSelector)
});

export default (component, { pageType, floorSelector }) =>
  connect(mapStateToProps(pageType, floorSelector))(component);
